<template>
  <div
    class="ma-0 px-2 d-flex blue align-center justify-center elevation-2 rounded-r-0 rounded-l"
    :class="right ? 'right' : 'template-label'"
  >
    <v-icon size="16" color="white" class="me-1">mdi-creation-outline</v-icon>
    <p class="subtitle-2 ma-0 pa-0 white--text">
      {{ $t('routines.template') }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'TemplateLabel',

  props: {
    right: Boolean,
  },
}
</script>
<style lang="scss" scoped>
.template-label {
  min-width: 99px;
  height: 32px;
  position: absolute;
  left: -85px;
  top: 20px;
}
.right {
  min-width: 99px;
  height: 32px;
  position: absolute;
  right: 0px;
  top: 16px;
}
</style>
